import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { RiQuestionLine } from 'react-icons/ri'
import { FiX } from 'react-icons/fi'
import Modal from 'react-modal'
import usePersistedState from '../../hooks/usePersistedState'
import Button from '../../components/Button'
import Header from '../../components/Header'

import {
  Container,
  Content,
  GoalItem,
  BtnVoltar,
  TaxationBox,
  Line,
} from './styles'
import { UserDetails } from '../../utils/interfaces'

import tabelaIR from '../../assets/tabelaIR.jpg'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'

const progressiveData = [
  { rendimento: 'Até R$ 2.112,00', aliquota: 'isento', deduzir: '-' },
  { rendimento: 'De R$ 2.112,01 até R$ 2.826,65', aliquota: '7,5%', deduzir: 'R$ 158,40' },
  { rendimento: 'De R$ 2.826,66 até R$ 3.751,05', aliquota: '15%', deduzir: 'R$ 370,40' },
  { rendimento: 'De R$ 3.751,06 até R$ 4.664,68', aliquota: '22,5%', deduzir: 'R$ 651,73' },
  { rendimento: 'Acima de R$ 4.664,68', aliquota: '27,5%', deduzir: 'R$ 884,96' },
]

const regressiveData = [
  { prazo: 'Até 2 anos', aliquota: '35%', },
  { prazo: 'Acima de 2 anos até 4 anos', aliquota: '30%' },
  { prazo: 'Acima de 4 anos até 6 anos', aliquota: '25%' },
  { prazo: 'Acima de 6 anos até 8 anos', aliquota: '20%' },
  { prazo: 'Acima de 8 anos até 10 anos', aliquota: '15%' },
  { prazo: 'Acima de 10 anos', aliquota: '10%' },
]

const GoalSelection: React.FC = () => {
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [selected, setSelected] = useState(userDetails.tributacao)

  const [isModalOpen, setIsModalOpen] = useState(false)

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  const history = useHistory()

  const today = new Date()
  const dataAdesao = new Date(
    today.getFullYear(),
    today.getMonth() + 2,
    0,
  ).toLocaleDateString()

  const [descricTrib, setDescricTrib] = useState(
    `Conforme legislação (Lei nº 11053/2004) a opção do IR poderá ser realizada até o dia ${dataAdesao},
    caso não haja a manifestação será presumido o regime progressivo, conforme legislação vigente.`,
  )

  const handleGoalItem = useCallback(valor => {
    if (valor === 'P') {
      setSelected(valor)
      setDescricTrib(
        `Esta opção é irretratável. Os eventuais recursos recebidos a título
          de resgate estarão sujeitos à incidência de imposto de renda na fonte
          à alíquota de 15%, independentemente do valor do resgate,
          como antecipação do devido na declaração de ajuste anual.
          Os benefícios serão tributados na fonte, de acordo com a tabela
          progressiva do imposto de renda e levados a ajuste na declaração anual.`,
      )
    } else if (valor === 'R') {
      setSelected(valor)
      setDescricTrib(
        `Esta opção é irretratável. Mesmo na hipótese de eventual transferência
          ou portabilidade, e dela resultará que os valores recebidos a título
          de resgate ou benefício estarão sujeitos à incidência na fonte, do
          imposto de renda calculado de acordo com as alíquotas aplicáveis
          nesse regime, em caráter definitivo e, portanto, não sujeitos a
          ajustes na declaração anual.`,
      )
    }
  }, [])

  const handleContinue = useCallback(async () => {
    await setUserDetails({
      ...userDetails,
      tributacao: selected,
    })

    history.push('/new-participant')
  }, [history, selected, setUserDetails, userDetails])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <div className="app_title">
            <strong>Escolha o regime de Tributação:</strong>
            {/* <RiQuestionLine onClick={() => setIsModalOpen(true)} /> */}
          </div>
          <p>
            Você deve definir qual regime de tributação será aplicado no momento
            em que receber o benefício ou resgatar o dinheiro aplicado.
          </p>
          <TaxationBox>
            <GoalItem
              key="1"
              isSelected={selected === 'P'}
              onClick={() => handleGoalItem('P')}
            >
              <span>Progressivo</span>
            </GoalItem>
            <GoalItem
              key="2"
              isSelected={selected === 'R'}
              onClick={() => handleGoalItem('R')}
            >
              <span>Regressivo</span>
            </GoalItem>
          </TaxationBox>

          <Line />
          <footer>
            <p>{descricTrib}</p>
          </footer>
        </Content>

        <Button
          type="button"
          color="blue"
          onClick={handleContinue}
          disabled={!selected}
        >
          Continuar
        </Button>
        <BtnVoltar type="button" onClick={() => history.goBack()}>
          &lt; Anterior
        </BtnVoltar>

        <Modal
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          overlayClassName="react-modal-overlay"
          className="react-modal-content modal-content-image"
        >
          <FiX onClick={handleCloseModal} />
          <img src={tabelaIR} alt="" />
        </Modal>
      </Container>
    </>
  )
}

export default GoalSelection
